import React from 'react'
import Items from './items'
import Paging from './paging'
import Winpop from './winnerPop'
import { Api } from '../../libs/api'

class List extends React.Component {
    goRd = 0

    constructor(props) {
        super(props)
        this.state = {
            eventList: {},
            pageNation: {},
        }
    }

    componentDidMount() {
        this.getList(this.props)
    }

    componentWillReceiveProps(np) {
        this.getList(np)
    }

    getList = (op, page) => {
        let pg = page
        const { kWord, isMy } = op
        pg = pg > 1 ? pg : 1
        const opt = {
            pageSize: 10,
            f_win: '1,2',
            search_value: kWord,
            page: pg,
            f_proc: 3,
        }
        if (isMy) opt.my_evt_join = 1
        this.goRd = 0
        Api.getEvents(opt).then(response => {
            if (response.data.code === '200') {
                this.goRd = 2
                this.setState({ eventList: response.data.data.eventList, pageNation: response.data.data.pagenation })
            }
        })
    }

    eventSearch = id => {
        let sword = document.getElementById(id).value
        if (sword === '') sword = true
        this.getList(15, null, sword)
    }

    pageCont(e, pn) {
        e.stopPropagation()
        this.getList(this.props, pn)
    }

    render() {
        const { eventList, pageNation } = this.state
        if (eventList.length === undefined) return <p className="box-loading" />
        const userName = this.props.user.user_name
        return (
            <React.Fragment>
                <table className="evtWMtable">
                    <colgroup>
                        <col width="65" />
                        <col width="*" />
                        <col width="205" />
                        <col width="90" />
                        {this.props.isMy && <col width="60" />}
                        <col width="100" />
                        <col width="80" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>이벤트명</th>
                            <th>이벤트 기간</th>
                            <th>당첨자 발표일</th>
                            {this.props.isMy && <th className="iswin">결과</th>}
                            <th>댓글 마감일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {eventList.length === 0 ? (
                            <tr className="noRst">
                                <td colSpan={this.props.isMy ? 6 : 5}>
                                    <br />
                                    <br />
                                    <h1>조건에 맞는 결과가 없습니다.</h1>
                                    <br />
                                    <br />
                                </td>
                            </tr>
                        ) : (
                            eventList.map((v, i) => {
                                const key = i
                                return <Items key={key} id={i + 1} value={v} isMy={this.props.isMy} />
                            })
                        )}
                    </tbody>
                </table>
                <Paging data={pageNation} pageCont={(e, pn) => this.pageCont(e, pn)} />
                <Winpop userName={userName} />
            </React.Fragment>
        )
    }
}
export default List
